export const changeCommaForDot = (value: string) => {
  return value?.replace(',', '.')
}

export const changeDotForComma = (value: string) => {
  return value.replace('.', ',')
}

export const fixedSixDecimal = (value = 0) => {
  return value.toFixed(6)
}

export const isMultipleOfPackaging = (quantity: number, packaging: number) => {
  return quantity % packaging === 0
}

export const fixedTwoDecimal = (value = 0, totalDecimal?: number) => {
  return value.toFixed(totalDecimal ?? 2);
}
